import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVDropdown } from "../../shared/JVDropdown";
import { IVendorCompanyMast } from "../../models/VendorCompanyMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { Card } from "primereact/card";
import { IDesignationMastDropdown } from "../../models/IDropdown";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean;
    onHide: () => void;
    singleData: IVendorCompanyMast;
    toast: any;
}

export interface IVendorAccountDetailsList {
    account_Person_ID?: number;
    vendor_Company_ID?: number;
    vendor_Company_Name?: string;
    account_Person_Name: string;
    account_Person_Email: string;
    account_Person_Desk: string;
    account_Person_Cell?: string | null;
    designationId?: number,
    designation_Name?: string,
    addedBy?: string,
    added_On?: Date,
    updated_By?: string,
    updated_On?: Date,
}

export interface IVendorAccountDetails {
    account_Person_ID?: number;
    vendor_Company_ID?: number;
    account_Person_Name: string;
    account_Person_Email: string;
    account_Person_Desk: string;
    account_Person_Cell?: string | null;
    designationId?: number,
}

const schema = yup.object({
    vendor_Company_ID: yup.number().nullable(),
    account_Person_Name: yup.string().required("Account Person Name is required*"),
    account_Person_Email: yup.string().required("Account Person Email is required*").email("Account Person Email must be a valid email"),
    account_Person_Desk: yup.string().nullable(),
    account_Person_Cell: yup.string().required("Cell Phone is required*"),
    designationId: yup.number().min(1, "Designation is required*").required("Designation is required*"),
});

export const VendorCompanyAccounts = () => {
    const [tableDataMain, setTableDataMain] = useState({ tableData: [], loading: false } as { tableData: Array<IVendorCompanyMast>, loading: boolean });
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVendorAccountDetailsList>, loading: boolean });
    const [vendors, setVendors] = useState<Array<{ vendortypeid?: number, vendor_Type?: string, }>>([]);
    const [vendorCompanies, setVendorCompanies] = useState<Array<{ vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, }>>([]);
    const [value2, setValue2] = useState(null as { vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, } | null);
    const [selectedVendor, setSelectedVendor] = useState(null as number | null);
    const [designations, setDesignations] = useState<Array<IDesignationMastDropdown>>();
    const [dispalyTable, setDispalyTable] = useState<boolean>(false);
    const [dispalyForm, setDispalyForm] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const toast = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IVendorAccountDetails>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const loadVedorTypes = async () => {
        const repsonse = await Fetch("DropDown/vendorTypes", "GET", null, null, toast);
        if (repsonse) {
            const data: Array<{ vendortypeid?: number, vendor_Type?: string, }> = await repsonse.json();
            setVendors(data);
        }
    };

    const onSubmit = async (data: IVendorAccountDetails) => {
        if (data.account_Person_Name.includes("0") || data.account_Person_Name.includes("1") || data.account_Person_Name.includes("2") || data.account_Person_Name.includes("3") || data.account_Person_Name.includes("4") || data.account_Person_Name.includes("5") || data.account_Person_Name.includes("6") || data.account_Person_Name.includes("7") || data.account_Person_Name.includes("8") || data.account_Person_Name.includes("9")) {
            toast.current.show({ severity: 'error', detail: "Accounts Person Name Can not have Number.", life: 3000 });
        } else if (value2 !== null && value2?.vendor_Company_ID !== null && value2?.vendor_Company_ID !== undefined && value2?.vendor_Company_ID !== 0) {
            setLoading(true);
            let newData: IVendorAccountDetails = data;
            newData.vendor_Company_ID = value2?.vendor_Company_ID;
            const response = await Fetch("Vendor_Company_Mast/saveAccountDetails", (newData.account_Person_ID !== null && newData.account_Person_ID !== undefined && newData.account_Person_ID !== 0) ? "PUT" : "POST", newData, null, toast);
            if (response) {
                toast.current.show({ severity: 'success', detail: "Select the State First.", life: 3000 });
                reset({
                    vendor_Company_ID: 0,
                    account_Person_Name: "",
                    account_Person_Email: "",
                    account_Person_Desk: "",
                    account_Person_Cell: "",
                });
                loadTableData(value2?.vendor_Company_ID || 0);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } else {
            toast.current.show({ severity: 'error', detail: "Select A Vendor Company First.", life: 3000 });
        }
    }

    const onHide = () => {
        setLoading(false);
        setVendorCompanies([]);
        setValue2(null);
        setSelectedVendor(null);
        setDispalyForm(prev => prev = false);
        setDispalyTable(prev => prev = false);
        reset({
            vendor_Company_ID: 0,
            account_Person_Name: "",
            account_Person_Email: "",
            account_Person_Desk: "",
            account_Person_Cell: "",
        });
        setTableData({ tableData: [], loading: false });
        setTableDataMain({ tableData: [], loading: false });
    };

    const loadDesignations = async () => {
        const response = await Fetch("Dropdown/designation", "GET", null, null, null);
        if (response) {
            const data: Array<IDesignationMastDropdown> = await response.json();
            setDesignations(data);
        }
    }

    const removeDetails = async (rowData: IVendorAccountDetailsList) => {
        const response = await Fetch("Vendor_Company_Mast/removeAccountDetails", "DELETE", null, `account_Person_ID=${rowData.account_Person_ID}`, toast);
        if (response) {
            toast.current.show({ severity: 'success', detail: "Account Person Details Removed Successfully.", life: 3000 });
            //loadTableData(0);
        } else {
            toast.current.show({ severity: 'error', detail: "Failed to Remove Account Person Details.", life: 3000 });
        }
    }

    const rejectFunc = () => {
    };

    const removeDetailsDetails = (rowData: IVendorAccountDetailsList) => {
        confirmDialog({
            message: `Are you sure you want to remove accounts details?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => removeDetails(rowData),
            reject: () => rejectFunc()
        });
    }

    const actionBodyTemplate = (rowData: IVendorAccountDetails) => {
        const data: IVendorAccountDetails = {
            account_Person_ID: rowData.account_Person_ID,
            vendor_Company_ID: rowData.vendor_Company_ID,
            account_Person_Name: rowData.account_Person_Name,
            account_Person_Email: rowData.account_Person_Email,
            account_Person_Desk: rowData.account_Person_Desk,
            account_Person_Cell: rowData.account_Person_Cell,
            designationId: rowData?.designationId,
        }
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => reset(data)} />
                {(_roles.includes(1) || _roles.includes(26)) && <Button icon="pi pi-trash" className="p-button-rounded p-button-text mr-1" style={{ color: "red" }} onClick={() => removeDetailsDetails(data)} />}
            </div>
        );
    };

    const loadTableData = async (companyID: number) => {
        setDispalyForm(prev => prev = false);
        setTableData({ tableData: tableData.tableData, loading: true });
        const repsonse = await Fetch("Vendor_Company_Mast/getAccountDetails", "GET", null, `companyID=${companyID}`, toast);
        if (repsonse) {
            const data: Array<IVendorAccountDetailsList> = await repsonse.json();
            setTableData({ tableData: data, loading: false });
            setDispalyForm(prev => prev = true);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const loadTableData2 = async (companyID: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setDispalyTable(prev => prev = false);
        const repsonse = await Fetch("Vendor_Company_Mast/getVendorCompanyDetails", "GET", null, `companyID=${companyID}`, toast);
        if (repsonse) {
            const data: IVendorCompanyMast = await repsonse.json();
            setTableDataMain({ tableData: [data], loading: false });
            loadTableData(companyID);
            setDispalyTable(prev => prev = true);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const loadVendorCompanies = async (query: string) => {
        const repsonse = await Fetch("Vendor_Company_Mast/vendorCompanies", "GET", null, `query=${query}&vendorType=${selectedVendor}`, toast);
        if (repsonse) {
            const data: Array<{ vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, }> = await repsonse.json();
            setVendorCompanies(data);
        }
    }

    const completeMethodVendorCompany = (event: { query: string }) => {
        if (selectedVendor !== null && selectedVendor !== 0) {
            loadVendorCompanies(event.query);
        } else toast.current.show({ severity: 'error', detail: "Select Vendor Type First.", life: 3000 });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2 flex gap-3">
                    <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => {
                        onHide();
                    }} />
                    <Dropdown value={selectedVendor} onChange={(e) => {
                        setSelectedVendor(e.value);
                        // onHide();
                    }} options={vendors} optionLabel="vendor_Type" optionValue="vendortypeid" placeholder="Select Vendor Type" className="w-full md:w-14rem" />
                    <div>
                        <AutoComplete suggestions={vendorCompanies} completeMethod={completeMethodVendorCompany} field={"vendor_Company_Name"} forceSelection value={value2} placeholder={"Search Vendor Company"} onChange={(e) => setValue2(e.value)} />
                        <Button icon="pi pi-search" className="p-button p-button-info mr-2" onClick={() => {
                            if (value2 !== null && value2?.vendor_Company_ID !== null && value2?.vendor_Company_ID !== 0) {
                                loadTableData2(value2?.vendor_Company_ID || 0);
                            } else toast.current.show({ severity: 'error', detail: "Select Vendor Company First.", life: 3000 });
                        }} />
                    </div>
                </div>
            </React.Fragment>
        );
    };

    useEffect(() => {
        //vendorCompanies
        loadDesignations();
        loadVedorTypes();
    }, []);

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            {dispalyTable === true && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "2rem" }}
                size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableDataMain.tableData} lazy dataKey="id"
                header={<p></p>}
                loading={tableDataMain.loading}
            >
                <Column field="vendor_Company_Name" header="Company Name" />
                <Column field="vendor_Company_FidNo" header="FID#" />
                <Column field="vendor_Company_Phone" header="Phone No." />
                <Column field="vendor_Company_FaxNo" header="Fax No." />
                <Column field="vendor_Type_Name" header="Vendor Type" />
                <Column field="city_Name" header="City" />
                <Column field="state_Name" header="State Name" />
                <Column field="major_Technology" header="Major Technology" />
                <Column field="website_URL" header="Website Url" body={(rowData: any) => <a target="_blank" href={rowData.website_URL}>{rowData.website_URL}</a>} />
                <Column field="disable_Share_PV" header="Disable Share PV" body={(rowData: any) => <p style={{ color: rowData.disable_Share_PV ? 'green' : 'red' }}>{rowData.disable_Share_PV ? "Yes" : "No"}</p>} />

                {/* <Column body={actionBodyTemplate} /> */}
            </DataTable>}
            {dispalyForm === true && <Card style={{ marginTop: "2rem" }}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <JVInput column={3} required label="Accounts Person Name" control={control} name="account_Person_Name" error={errors.account_Person_Name?.message} />
                    <JVInput column={3} required label="Account Person Email" control={control} name="account_Person_Email" error={errors.account_Person_Email?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" required label="Cell No" control={control} name="account_Person_Cell" error={errors.account_Person_Cell?.message} />
                    <JVInputMask column={3} mask="(999) 999-9999" label="Desk No" control={control} name="account_Person_Desk" error={errors.account_Person_Desk?.message} />
                    <JVDropdown column={3} required label="Designation" control={control} name="designationId" error={errors.designationId?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />

                    <div style={{ marginBottom: '20px', width: '100%' }}></div>

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CLEAR" onClick={() => reset({
                            vendor_Company_ID: 0,
                            account_Person_Name: "",
                            account_Person_Email: "",
                            account_Person_Desk: "",
                            account_Person_Cell: "",
                            designationId: 0
                        })} type="button" className="p-button-outlined surface-200"></Button>
                    </div>
                </form>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData} lazy dataKey="id"
                    emptyMessage="No Persons found."
                    header={<></>}
                    loading={tableData.loading}
                >
                    <Column field="account_Person_Name" header="Name" sortable />
                    <Column field="account_Person_Email" header="Email" sortable />
                    <Column field="account_Person_Desk" header="Desk No." />
                    <Column field="account_Person_Cell" header="Cell No." sortable />
                    <Column field="designation_Name" header="Vendor Designation" />
                    <Column field="addedBy" header="Added By" />
                    {/* <Column field="added_On" header="Added On" body={(rowData: IVendorAccountDetailsList) => {
                        let date;
                        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} /> */}
                    <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="updated_By" header="Updated By" />
                    {/* <Column field="updated_On" header="Updated On" body={(rowData: IVendorAccountDetailsList) => {
                        let date;
                        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} /> */}

                    <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat)} />
                    <Column body={actionBodyTemplate} />
                </DataTable>
            </Card>}
            <Toast ref={toast} />
            <ConfirmDialog />
        </>
    );
}